// ============================================
// components/Avatar.tsx
// 字母头像(纯 CSS, 零依赖, 零外部请求, 无协议风险).
// 取昵称首字 + 暖黄渐变底色. 同一昵称稳定生成同一配色.
// ============================================

import { useMemo } from 'react';

interface Props {
  name?: string | null;   // 昵称, 取首字
  size?: number;
  className?: string;
}

// 一组暖黄/琥珀系渐变(社区主色调), 按名字哈希稳定选取
const PALETTE: [string, string][] = [
  ['#f0c14b', '#e0a020'],
  ['#f5b942', '#d9920f'],
  ['#ecc66a', '#caa01f'],
  ['#f3a93c', '#d98512'],
  ['#e8b94f', '#c89015'],
  ['#f0cd6b', '#d4aa28'],
];

function hashName(s: string): number {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return h;
}

// 取首字: 中文取第一个字, 英文取首字母大写, 空则用 "?"
function initial(name: string): string {
  const t = (name || '').trim();
  if (!t) return '?';
  return t[0].toUpperCase();
}

export default function Avatar({ name, size = 48, className = '' }: Props) {
  const { ch, from, to } = useMemo(() => {
    const t = (name || '').trim() || '?';
    const [f, g] = PALETTE[hashName(t) % PALETTE.length];
    return { ch: initial(t), from: f, to: g };
  }, [name]);

  return (
    <div
      className={`grid place-items-center rounded-2xl select-none ${className}`}
      style={{
        width: size,
        height: size,
        background: `linear-gradient(135deg, ${from}, ${to})`,
        color: '#fff',
        fontWeight: 700,
        fontSize: size * 0.44,
        fontFamily: '"Sora", "Noto Sans SC", system-ui, sans-serif',
        lineHeight: 1,
        textShadow: '0 1px 2px rgba(120,80,0,.25)',
      }}
      aria-label={name || undefined}
    >
      {ch}
    </div>
  );
}
